<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="340"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="success"
        :dark="!disabled"
        :disabled="disabled"
        v-on="on"
      >
        {{ $t('message.approve_targets_button')
        }}<v-icon
          right
          dark
        >
          fa-check
        </v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline">
        {{ $t('message.confirm_approve_targets_title') }}
      </v-card-title>
      <v-card-text>
        {{ $t('message.confirm_approve_targets_text') }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          flat
          @click="show = false"
        >
          {{ $t('message.approve_targets_dialog_no_button') }}
        </v-btn>
        <v-btn
          color="primary"
          @click="$emit('confirm')"
        >
          {{ $t('message.approve_targets_dialog_yes_button') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    disabled: Boolean,
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
  },
}
</script>
